<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('activity.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content-top">
            <div class="time-box">
                <div class="time-item" :class="{'time-active': activeTime === 1}"
                     @click="changeTimeType(1, $t('dailyActive.time0'))">{{ $t('dailyActive.time0') }}
                </div>
                <div class="time-item" :class="{'time-active': activeTime === 2}"
                     @click="changeTimeType(2, $t('dailyActive.time1'))">{{ $t('dailyActive.time1') }}
                </div>
            </div>
            <div class="time-select">
                <img @click="timeLeft" class="time-icon" :class="{'arr-opacity' : showLeftOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/03left.svg`)">
                <div class="time-date">{{ time }}</div>
                <img @click="timeRight" class="time-icon" :class="{'arr-opacity' : showRightOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/04right.svg`)">
            </div>
            <div class="avg-score-box">
                <img class="score-bg" :src="require(`@/assets/theme/${theme}/status/06sleep/07scoreBg.png`)">
                <div class="avg-score-title">{{ $t('sleep.avgScore') }}</div>
                <div class="avg-score-value">{{
                        noData ? '--' : (activityInfo.activityRangeMath && activityInfo.activityRangeMath.score != null ? activityInfo.activityRangeMath.score : '--')
                    }}
                </div>
                <div class="compare-box"
                     v-if="!noData && activityInfo.activityRangeMath && activityInfo.activityRangeMath.scoreLast != null">
                    <img
                        :src="activityInfo.activityRangeMath.score >= activityInfo.activityRangeMath.scoreLast ? require('@/assets/theme/light/status/06sleep/08up.svg') : require('@/assets/theme/light/status/06sleep/08down.svg')">
                    {{ Math.abs(activityInfo.activityRangeMath.score - activityInfo.activityRangeMath.scoreLast) }}
                </div>
                <div class="compare-text">{{ $t(activeTime === 2 ? 'sleep.vsLastMonth' : 'sleep.vsLastWeek') }}</div>
            </div>
        </div>
        <div>
            <div class="suggest-title">{{ $t('activity.activityScore') }}</div>
            <div class="score-chart-box">
                <div class="score-chart-out">
                    <div id="score-chart"></div>
                    <div id="y-axis-lines">
                        <div style="height: 25%; background-color: var(--chart-color-3);"></div>
                        <div style="height: 25%; background-color: var(--chart-color-5);"></div>
                        <div style="height: 50%; background-color: var(--chart-color-15);"></div>
                    </div>
                </div>

                <div class="score-item">
                    <div class="score-img-box">
                        <img class="score-img" src="@/assets/theme/light/status/06sleep/09scoreBg.svg">
                        <div v-if="sleepDays" class="score-ratio score-color-1"
                             :style="{'width': scoreRatioArr[0] / sleepDays * 140 + 'px'}"></div>
                        <div class="score-color-bar score-color-1"></div>
                    </div>
                    <div class="score-text">{{ scoreRatioArr[0] }}{{ $t('sleep.days') }}</div>
                    <div class="score-num-level">{{ $t('sleep.scoreGe80') }}</div>
                </div>
                <div class="score-item">
                    <div class="score-img-box">
                        <img class="score-img" src="@/assets/theme/light/status/06sleep/09scoreBg.svg">
                        <div v-if="sleepDays" class="score-ratio score-color-2"
                             :style="{'width': scoreRatioArr[1] / sleepDays * 140 + 'px'}"></div>
                        <div class="score-color-bar score-color-2"></div>
                    </div>
                    <div class="score-text">{{ scoreRatioArr[1] }}{{ $t('sleep.days') }}</div>
                    <div class="score-num-level">{{ $t('sleep.score60to79') }}</div>
                </div>
                <div class="score-item">
                    <div class="score-img-box">
                        <img class="score-img" src="@/assets/theme/light/status/06sleep/09scoreBg.svg">
                        <div v-if="sleepDays" class="score-ratio score-color-3"
                             :style="{'width': scoreRatioArr[2] / sleepDays * 140 + 'px'}"></div>
                        <div class="score-color-bar score-color-3"></div>
                    </div>
                    <div class="score-text">{{ scoreRatioArr[2] }}{{ $t('sleep.days') }}</div>
                    <div class="score-num-level">{{ $t('sleep.scoreLe60') }}</div>
                </div>
                <div class="score-suggest">{{ $t('sleep.suggestText') }}</div>
            </div>
            <div class="suggest-title">{{ $t('activity.moderateVigorousTime') }}</div>
            <div class="score-chart-box">
                <div class="avg-duration-title">{{ $t('activity.avgModVigTime') }}</div>
                <div class="vs-line">
                    <div class="avg-efficiency-line">
                        <div class="avg-efficiency-value">{{
                                noData ? '--' : (activityInfo.activityRangeMath && activityInfo.activityRangeMath.sportStrengthAvg != null ? format(Math.ceil(activityInfo.activityRangeMath.sportStrengthAvg)) : '--')
                            }}
                        </div>
                        <div class="avg-efficiency-unit">{{ $t('activity.minUnit') }}</div>
                        <div class="avg-efficiency-compare"
                             v-if="!noData && activityInfo.activityRangeMath && activityInfo.activityRangeMath.sportStrengthAvgLast != null">
                            <img
                                :src="activityInfo.activityRangeMath.sportStrengthAvg >= activityInfo.activityRangeMath.sportStrengthAvgLast ? require('@/assets/theme/light/status/06sleep/08up.svg') : require('@/assets/theme/light/status/06sleep/08down.svg')">
                            <span class="avg-efficiency-compare-value">{{
                                    format(Math.abs(activityInfo.activityRangeMath.sportStrengthAvg - activityInfo.activityRangeMath.sportStrengthAvgLast))
                                }}</span>
                        </div>
                    </div>
                    <div class="vs-text">{{
                            $t(activeTime === 2 ? 'sleep.vsLastMonthTitle' : 'sleep.vsLastWeekTitle')
                        }}
                    </div>
                </div>
                <div class="fall-box" id="efficiency-chart"></div>
            </div>
            <div class="suggest-title">{{ $t('activity.calories') }}</div>
            <div class="score-chart-box">
                <div class="avg-duration-title">{{ $t('activity.avgCalories') }}</div>
                <div class="vs-line">
                    <div class="avg-efficiency-line">
                        <div class="avg-efficiency-value">{{
                                noData ? '--' : (activityInfo.activityRangeMath && activityInfo.activityRangeMath.calorieAvg != null ? format(Math.ceil(activityInfo.activityRangeMath.calorieAvg / 1000)) : '--')
                            }}
                        </div>
                        <div class="avg-efficiency-unit">{{ $t('unit.kcal') }}</div>
                        <div class="avg-efficiency-compare"
                             v-if="!noData && activityInfo.activityRangeMath && activityInfo.activityRangeMath.calorieAvgLast != null">
                            <img
                                :src="activityInfo.activityRangeMath.calorieAvg >= activityInfo.activityRangeMath.calorieAvgLast ? require('@/assets/theme/light/status/06sleep/08up.svg') : require('@/assets/theme/light/status/06sleep/08down.svg')">
                            <span class="avg-efficiency-compare-value">{{
                                    format(Math.ceil(Math.abs(activityInfo.activityRangeMath.calorieAvg - activityInfo.activityRangeMath.calorieAvgLast) / 1000))
                                }}</span>
                        </div>
                    </div>
                    <div class="vs-text">{{
                            $t(activeTime === 2 ? 'sleep.vsLastMonthTitle' : 'sleep.vsLastWeekTitle')
                        }}
                    </div>
                </div>
                <div id="range-chart" key="myCharts2"></div>
            </div>
            <div class="suggest-title">{{ $t('activity.steps') }}
                <img class="info-icon" @click="toSleepStage"
                     :src="require(`@/assets/theme/${theme}/status/06sleep/01info.svg`)">
            </div>
            <div class="score-chart-box">
                <div class="avg-duration-title">{{ $t('activity.avgSteps') }}</div>
                <div class="vs-line">
                    <div class="avg-efficiency-line">
                        <div class="avg-efficiency-value">{{
                                noData ? '--' : (activityInfo.activityRangeMath && activityInfo.activityRangeMath.stepAvg != null ? format(Math.ceil(activityInfo.activityRangeMath.stepAvg)) : '--')
                            }}
                        </div>
                        <div class="avg-efficiency-unit">{{ $t('activity.stepsUnit') }}</div>
                        <div class="avg-efficiency-compare"
                             v-if="!noData && activityInfo.activityRangeMath && activityInfo.activityRangeMath.stepAvgLast != null">
                            <img
                                :src="activityInfo.activityRangeMath.stepAvg >= activityInfo.activityRangeMath.stepAvgLast ? require('@/assets/theme/light/status/06sleep/08up.svg') : require('@/assets/theme/light/status/06sleep/08down.svg')">
                            <span class="avg-efficiency-compare-value">{{
                                    format(Math.abs(activityInfo.activityRangeMath.stepAvg - activityInfo.activityRangeMath.stepAvgLast))
                                }}</span>
                        </div>
                    </div>
                    <div class="vs-text">{{
                            $t(activeTime === 2 ? 'sleep.vsLastMonthTitle' : 'sleep.vsLastWeekTitle')
                        }}
                    </div>
                </div>
                <div id="stability-chart" key="myCharts2"></div>
            </div>
        </div>
    </div>
</template>

<script>
import {getQueryVariable, getSkin} from '@/utils/comment'
import {
    getToday,
    getNWeekFirstDay,
    getNWeekLastDay,
    getMonthStartDay,
    getMonthEndDay,
    GetDateStr, SwitchTime24,
    changeDate,
    changeMonthDate,
    GetYear,
    GetMinute,
    calculateDuration, getDateWeek, getDateDay, convertTo12Hour
} from "../../utils/dateUtils";
import VueMarkdown from "vue-markdown";
import {WebJSBridge} from "../../utils/JSBridge1";
import {format} from '@/utils/math'

export default {
    name: 'sleep',
    components: {VueMarkdown},
    data() {
        return {
            ratio: 1,
            theme: getQueryVariable("theme") ? getQueryVariable("theme") : "light",
            activeTime: 1,
            time: '',
            startDate: '',
            endDate: '',
            tNum: 0,
            wNum: 0,
            mNum: 0,
            activityInfo: {},
            score: '--',
            showLeftOpacity: 0,
            showRightOpacity: 1,
            scoreChart: null,
            symbol: 0,
            dateSleep: [], // 每日睡眠数据
            sleepDays: 0, // 范围天数
            scoreRatioArr: [0, 0, 0], // >=80、60-70、<60天数占比
            efficiencyChart: null, // 睡眠效率图
            stabilityChart: null, // 睡眠稳定性图
            rangeChart: null, // 睡眠阶段图
            noData: true,
        }
    },
    mounted() {
        this.ratio = document.body.clientWidth / 375 ? document.body.clientWidth / 375 : 1;
        this.changeTimeType(1, this.$t('dailyActive.time0'))
    },
    methods: {
        back() {
            WebJSBridge.call("closeWeb", null, function (res) {
            });
        },
        checkOpacity() {
            if (this.activeTime == 0 && this.tNum <= 0) {
                this.showRightOpacity = 1
            } else if (this.activeTime == 1 && this.wNum >= 0) {
                this.showRightOpacity = 1
            } else if (this.activeTime == 2 && this.mNum >= 0) {
                this.showRightOpacity = 1
            } else {
                this.showRightOpacity = 0
            }
            if (this.activeTime == 0 && this.startDate <= '2020-01-01') {
                this.showLeftOpacity = 1
            } else if (this.activeTime == 1 && this.startDate <= '2020-01-01') {
                this.showLeftOpacity = 1
            } else if (this.activeTime == 2 && this.startDate <= '2020-01-01') {
                this.showLeftOpacity = 1
            } else {
                this.showLeftOpacity = 0
            }
        },
        timeLeft() {
            if (this.activeTime == 0 && this.startDate > '2020-01-01') {
                this.tNum++;
                this.startDate = GetDateStr(this.tNum);
                this.endDate = GetDateStr(this.tNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 1 && this.startDate > '2020-01-01') {
                this.wNum--;
                this.startDate = getNWeekFirstDay(this.wNum);
                this.endDate = getNWeekLastDay(this.wNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 2 && this.startDate > '2020-01-01') {
                this.mNum--;
                this.startDate = getMonthStartDay(this.mNum);
                this.endDate = getMonthEndDay(this.mNum);
                this.time = changeMonthDate(this.startDate);
            }
            this.getData();
        },
        timeRight() {
            if (this.activeTime == 0 && this.tNum > 0) {
                this.tNum--;
                this.startDate = GetDateStr(this.tNum);
                this.endDate = GetDateStr(this.tNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 1 && this.wNum < 0) {
                this.wNum++;
                this.startDate = getNWeekFirstDay(this.wNum);
                this.endDate = getNWeekLastDay(this.wNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 2 && this.mNum < 0) {
                this.mNum++;
                this.startDate = getMonthStartDay(this.mNum);
                this.endDate = getMonthEndDay(this.mNum);
                this.time = changeMonthDate(this.startDate);
            }
            this.getData();
        },
        changeTimeType(num, unit) {
            this.activeTime = num;
            if (this.activeTime == 1) {
                this.startDate = getNWeekFirstDay(this.wNum);
                this.endDate = getNWeekLastDay(this.wNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            }
            if (this.activeTime == 2) {
                this.startDate = getMonthStartDay(this.mNum);
                this.endDate = getMonthEndDay(this.mNum);
                this.time = changeMonthDate(this.startDate);
            }
            if (this.activeTime == 0) {
                this.startDate = GetDateStr(this.tNum);
                this.endDate = GetDateStr(this.tNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
            }
            this.getData();
        },
        getData() {
            this.checkOpacity();
            this.getActivityByRange();
        },
        getActivityByRange() {
            this.$api.status.getActivityByRange({
                startDate: this.startDate,
                endDate: this.endDate,
                type: this.activeTime == 1 ? 'week' : 'month'
            }).then(res => {
                if (res.info && res.info.activityRangeMath) {
                    const math = res.info.activityRangeMath
                    if (math.sportStrengthAvg > 0 || math.calorieAvg > 0 || math.stepAvg > 0) {
                        this.noData = false
                        this.activityInfo = res.info
                        this.processActivityData(res.info)
                    } else {
                        this.noData = true
                        this.activityInfo = res.info || {}
                        this.scoreRatioArr = [0, 0, 0]
                        this.sleepDays = 0
                        const xData = this.generateXAxisData()
                        this.$nextTick(() => {
                            this.drawScoreChart(xData, [])
                            this.drawEfficiencyChart(xData, [])
                            this.drawRangeChart(xData, [[], []])
                            this.drawStabilityChart(xData, [])
                        })
                    }
                } else {
                    this.noData = true
                    this.activityInfo = {}
                    this.scoreRatioArr = [0, 0, 0]
                    this.sleepDays = 0
                    const xData = this.generateXAxisData()
                    this.$nextTick(() => {
                        this.drawScoreChart(xData, [])
                        this.drawEfficiencyChart(xData, [])
                        this.drawRangeChart(xData, [[], []])
                        this.drawStabilityChart(xData, [])
                    })
                }
            })
        },
        processActivityData(info) {
            // 1. 处理评分分布数据
            const math = info.activityRangeMath || {}
            this.scoreRatioArr = [
                math.scoreGreater80 || 0,
                math.scoreGreater60 || 0,
                math.scoreLess60 || 0
            ]
            this.sleepDays = this.scoreRatioArr[0] + this.scoreRatioArr[1] + this.scoreRatioArr[2]

            // 2. 生成X轴日期数据
            const xData = this.generateXAxisData()

            // 3. 有数据标识

            // 4. 提取数据（按完整日期范围，无数据的补null）
            const count = xData.length
            const mapper = (list, fn) => Array.from({length: count}, (_, i) => {
                const item = (list || [])[i]
                if (item == null) return null
                return fn ? fn(item, i) : item
            })

            const sportStrengthList = mapper(info.sportStrengthAvgList)
            const calorieList = mapper(info.calorieAvgList, v => Math.ceil(v / 1000))
            const stepList = mapper(info.stepAvgList)

            // 5. 绘制各图表
            this.$nextTick(() => {
                let scoreChartData = []
                for (let i = 0; i < count; i++) {
                    scoreChartData.push(Math.ceil(Math.random() * 100))
                }
                this.drawScoreChart(xData, scoreChartData)
                this.drawEfficiencyChart(xData, [sportStrengthList, sportStrengthList])
                this.drawRangeChart(xData, [calorieList, calorieList])
                this.drawStabilityChart(xData, stepList)
            })
        },
        generateXAxisData() {
            const xData = []
            const start = new Date(this.startDate)
            const end = new Date(this.endDate)
            const current = new Date(start)
            while (current <= end) {
                const dateStr = current.getFullYear() + '-' +
                    (current.getMonth() + 1).toString().padStart(2, '0') + '-' +
                    current.getDate().toString().padStart(2, '0')
                const weekStr = this.$t('sleep.week' + getDateWeek(dateStr))
                xData.push(weekStr + '\n' + getDateDay(dateStr))
                current.setDate(current.getDate() + 1)
            }
            return xData
        },
        toSleepStage() {
            this.$router.push({
                name: 'sleepStage',
                query: {
                    lang: this.$i18n.locale
                }
            })
        },
        getItemColor(value) {
            if (value == null) return 'transparent';
            if (value < 50) return getSkin('--chart-color-154');
            if (value < 75) return getSkin('--chart-color-54');
            return getSkin('--chart-color-4');
        },
        getTopColor(value) {
            if (value == null) return 'transparent';
            if (value < 50) return getSkin('--chart-color-15');
            if (value < 75) return getSkin('--chart-color-5');
            return getSkin('--chart-color-3');
        },
        format(num) {
            return format(num)
        },
        drawScoreChart(xData, yData) {
            let _this = this;
            this.scoreChart = this.$echarts.init(document.getElementById("score-chart"));
            if (!this.noData) {
                const validY = yData.filter(v => v != null);
                const maxVal = validY.length > 0 ? Math.max(...validY) : 0;
                const minVal = validY.length > 0 ? Math.min(...validY) : 0;
                this.scoreChart.setOption({
                    grid: {
                        top: 17 * this.ratio,
                        bottom: 47 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    dataZoom: { // 放大和缩放
                        type: 'inside'
                    },
                    emphasis: {
                        disabled: true,
                    },
                    tooltip: {
                        borderColor: 'transparent',
                        backgroundColor: getSkin('--bg-color-3'),
                        trigger: 'axis',
                        position: (point, params, dom, rect, size) => {
                            let x = point[0] - size.contentSize[0] / 2;
                            let cWidth = 375 * _this.ratio;
                            if (x < 0) {
                                x = 0;
                            } else if ((x + size.contentSize[0]) > cWidth) {
                                x = cWidth - size.contentSize[0];
                            }
                            return [x, '0%'];
                        },
                        formatter: function (params, ticket, callback) {
                            let item = params[0];
                            let value = item.data ? item.data + 2 : 0;
                            if (value == 0) {
                                return
                            }
                            let html = '';
                            html += '<div style="font-size:13px;font-family:D-D;color: ' + getSkin('--text-color-3') + '">' + item.axisValue + '</div>'
                            html += '<div style="font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + value + '</span> </div>';
                            return html
                        }
                    },
                    xAxis: {
                        type: 'category',
                        z: 2,
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-3'),
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            fontFamily: "'D-D','SF'",
                            interval: this.activeTime === 2 ? 6 : 0,
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        max: 100,
                        interval: 25,
                        boundaryGap: [0, '10%'],
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3'),
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            showMinLabel: false,
                            fontFamily: "'D-D','SF'",
                            rich: {
                                color50: {
                                    color: getSkin('--chart-color-15')  // 29 的颜色
                                },
                                color75: {
                                    color: getSkin('--chart-color-5')   // 59 的颜色
                                },
                                color100: {
                                    color: getSkin('--chart-color-3')   // 79 的颜色
                                }
                            },
                            formatter: function (value) {
                                if (Math.abs(value - 50) < 0.1) {
                                    return '{color50|50}';
                                }
                                if (Math.abs(value - 75) < 0.1) {
                                    return '{color75|75}';
                                }
                                if (Math.abs(value - 100) < 0.1) {
                                    return '{color100|100}';
                                }
                                return '';
                            }
                        }
                    },
                    series: [
                        {
                            data: yData.map(val => val == null ? null : val - 2),
                            type: 'bar',
                            stack: 'total',
                            barWidth: '50%',
                            lineStyle: {
                                color: getSkin('--text-color-3'),
                                width: 2 * this.ratio
                            },
                            itemStyle: {
                                color: function (params) {
                                    const realVal = yData[params.dataIndex];
                                    return _this.getItemColor(realVal);
                                },
                                // borderWidth: barWidth,
                            },
                            label: {
                                show: true,
                                position: 'top',
                                color: getSkin('--text-color-1'),
                                fontSize: 11 * this.ratio,
                                fontWeight: 'bold',
                                formatter: (params) => {
                                    const realVal = yData[params.dataIndex];
                                    if (realVal == null || realVal === 0) return '';
                                    if (_this.activeTime == 2) {
                                        // 如果是最大值 或 最小值 → 显示数值
                                        if (realVal === maxVal || realVal === minVal) {
                                            return format(realVal);
                                        }
                                        // 其他都不显示
                                        return '';
                                    } else {
                                        return format(realVal);
                                    }

                                }
                            },
                        },
                        // 上层：顶部亮色部分
                        {
                            type: 'bar',
                            barWidth: '40%',
                            stack: 'total',
                            itemStyle: {
                                color: function (params) {
                                    const realValue = yData[params.dataIndex];
                                    return _this.getTopColor(realValue);
                                }
                            },
                            data: yData.map(val => val == null ? null : 2)
                        }
                    ]
                }, true)
                // this.scoreChart.setOption(option);
            } else {
                this.scoreChart.setOption({
                    grid: {
                        top: 17 * this.ratio,
                        bottom: 47 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    title: {
                        text: this.$t('noData'),
                        x: 'center',
                        y: 70 * this.ratio,
                        textStyle: {
                            fontFamily: 'Manteka',
                            fontSize: '12',
                            fontWeight: 'normal',
                            color: getSkin('--text-color-2')
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        max: 100,
                        boundaryGap: [0, '10%'],
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false
                        }
                    },
                    series: [
                        {
                            data: [],
                            type: 'line',
                        }
                    ]
                }, true)
            }
        },

        drawEfficiencyChart(xData, yData) {
            let _this = this;
            let barWidth = 16 * this.ratio;
            if (this.activeTime == 1) {
                barWidth = 16 * this.ratio;
            } else {
                barWidth = 4 * this.ratio;
            }
            this.efficiencyChart = this.$echarts.init(document.getElementById("efficiency-chart"));
            if (!this.noData) {
                // yData是二维数组，两个series用stack堆叠，需要对应位置相加求最大值
                let maxVal = 0;
                if (yData.length && yData[0]) {
                    for (let i = 0; i < yData[0].length; i++) {
                        const v0 = yData[0][i] == null ? 0 : yData[0][i];
                        const v1 = yData[1] && yData[1][i] != null ? yData[1][i] : 0;
                        maxVal = Math.max(maxVal, v0 + v1);
                    }
                }
                const minVal = 0;
                // 计算nice interval，确保yAxis正好显示5个刻度(含0)
                const rawInterval = (maxVal || 100) / 4;
                const magnitude = Math.pow(10, Math.floor(Math.log10(rawInterval + 0.0001)));
                const residual = rawInterval / magnitude;
                let niceInterval;
                if (residual <= 1) niceInterval = magnitude;
                else if (residual <= 2) niceInterval = 2 * magnitude;
                else if (residual <= 5) niceInterval = 5 * magnitude;
                else niceInterval = 10 * magnitude;
                const yMax = Math.ceil((maxVal || 100) / niceInterval) * niceInterval;
                const finalMax = Math.max(yMax, niceInterval * 4);
                this.efficiencyChart.setOption({
                    grid: {
                        top: 17 * this.ratio,
                        bottom: 72 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    legend: {
                        bottom: 12 * this.ratio,
                        right: 16 * this.ratio,
                        itemWidth: 15 * this.ratio,
                        itemHeight: 8 * this.ratio,
                        textStyle: {
                            color: getSkin('--text-color-1'),
                            fontSize: 11 * this.ratio,
                            fontFamily: "'D-D','SF'",
                        },
                        itemGap: 32 * this.ratio,
                    },
                    dataZoom: { // 放大和缩放
                        type: 'inside'
                    },
                    emphasis: {
                        disabled: true,
                    },
                    tooltip: {
                        borderColor: 'transparent',
                        backgroundColor: getSkin('--bg-color-3'),
                        trigger: 'axis',
                        position: (point, params, dom, rect, size) => {
                            let x = point[0] - size.contentSize[0] / 2;
                            let cWidth = 375 * _this.ratio;
                            if (x < 0) {
                                x = 0;
                            } else if ((x + size.contentSize[0]) > cWidth) {
                                x = cWidth - size.contentSize[0];
                            }
                            return [x, '0%'];
                        },
                        formatter: function (params, ticket, callback) {
                            let item = params[0];
                            let value = item.data ? item.data : 0;
                            if (value == 0) {
                                return
                            }
                            let html = '';
                            html += '<div style="font-size:13px;font-family:D-D;color: ' + getSkin('--text-color-3') + '">' + item.axisValue + '</div>'
                            html += '<div style="font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + value + '%</span> </div>';
                            return html
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            fontFamily: "'D-D','SF'",
                            interval: this.activeTime === 2 ? 6 : 0,
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        max: finalMax,
                        interval: niceInterval,
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3'),
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false,
                            fontFamily: "'D-D','SF'",
                        }
                    },
                    series: [
                        {
                            name: _this.$t('activity.vigorous'),
                            data: yData[0],
                            type: 'bar',
                            stack: 'total',
                            barWidth: barWidth,
                            label: { show: false },
                            itemStyle: {
                                color: getSkin('--chart-color-3'),
                                borderRadius: 2 * this.ratio,
                            },
                            emphasis: {
                                itemStyle: {
                                    color: getSkin('--chart-color-34'),
                                    borderRadius: 2 * this.ratio,
                                }
                            },
                        },
                        {
                            name: '',
                            type: 'bar',
                            stack: 'total',
                            barWidth: barWidth,
                            data: yData[0].map(v => v == null ? null : 2),
                            itemStyle: { color: 'rgba(0,0,0,0)' },
                            tooltip: {show: false },
                            legendHoverLink: false
                        },
                        {
                            name: _this.$t('activity.moderate'),
                            data: yData[1],
                            type: 'bar',
                            stack: 'total',
                            barWidth: barWidth,
                            label: {
                                show: true,
                                position: 'top',
                                color: getSkin('--text-color-1'),
                                fontSize: 11 * _this.ratio,
                                fontWeight: 'bold',
                                formatter: (params) => {
                                    if (params.data == null) return '';
                                    const deep = yData[0][params.dataIndex];
                                    const rem = yData[1][params.dataIndex];
                                    if (deep == null && rem == null) return '';
                                    const total = (deep || 0) + (rem || 0);
                                    if (total === 0) return '';
                                    if (_this.activeTime == 2) {
                                        if (total === maxVal || total === minVal) {
                                            return format(total);
                                        }
                                        return '';
                                    } else {
                                        return format(total);
                                    }
                                }
                            },
                            itemStyle: {
                                color: getSkin('--chart-color-5'),
                                borderRadius: 2 * this.ratio,
                            },
                            emphasis: {
                                itemStyle: {
                                    color: getSkin('--chart-color-54'),
                                    borderRadius: 2 * this.ratio,
                                }
                            },
                        }
                    ]
                }, true)
                // this.efficiencyChart.setOption(option);
            } else {
                this.efficiencyChart.setOption({
                    grid: {
                        top: 17 * this.ratio,
                        bottom: 47 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    title: {
                        text: this.$t('noData'),
                        x: 'center',
                        y: 70 * this.ratio,
                        textStyle: {
                            fontFamily: 'Manteka',
                            fontSize: '12',
                            fontWeight: 'normal',
                            color: getSkin('--text-color-2')
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        max: 100,
                        boundaryGap: [0, '10%'],
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false
                        }
                    },
                    series: [
                        {
                            data: [],
                            type: 'line',
                        }
                    ]
                }, true)
            }

        },
        drawRangeChart(xData, yData) {
            let _this = this;
            let barWidth = 16 * this.ratio;
            if (this.activeTime == 1) {
                barWidth = 16 * this.ratio;
            } else {
                barWidth = 4 * this.ratio;
            }
            this.efficiencyChart = this.$echarts.init(document.getElementById("range-chart"));
            if (!this.noData) {
                // yData是二维数组，两个series用stack堆叠，需要对应位置相加求最大值
                let maxVal = 0;
                if (yData.length && yData[0]) {
                    for (let i = 0; i < yData[0].length; i++) {
                        const v0 = yData[0][i] == null ? 0 : yData[0][i];
                        const v1 = yData[1] && yData[1][i] != null ? yData[1][i] : 0;
                        maxVal = Math.max(maxVal, v0 + v1);
                    }
                }
                const minVal = 0;
                // 计算nice interval，确保yAxis正好显示5个刻度(含0)
                const rawInterval = (maxVal || 100) / 4;
                const magnitude = Math.pow(10, Math.floor(Math.log10(rawInterval + 0.0001)));
                const residual = rawInterval / magnitude;
                let niceInterval;
                if (residual <= 1) niceInterval = magnitude;
                else if (residual <= 2) niceInterval = 2 * magnitude;
                else if (residual <= 5) niceInterval = 5 * magnitude;
                else niceInterval = 10 * magnitude;
                const yMax = Math.ceil((maxVal || 100) / niceInterval) * niceInterval;
                const finalMax = Math.max(yMax, niceInterval * 4);
                this.efficiencyChart.setOption({
                    grid: {
                        top: 17 * this.ratio,
                        bottom: 72 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    legend: {
                        bottom: 12 * this.ratio,
                        right: 16 * this.ratio,
                        itemWidth: 15 * this.ratio,
                        itemHeight: 8 * this.ratio,
                        textStyle: {
                            color: getSkin('--text-color-1'),
                            fontSize: 11 * this.ratio,
                            fontFamily: "'D-D','SF'",
                        },
                        itemGap: 32 * this.ratio,
                    },
                    dataZoom: { // 放大和缩放
                        type: 'inside'
                    },
                    emphasis: {
                        disabled: true,
                    },
                    tooltip: {
                        borderColor: 'transparent',
                        backgroundColor: getSkin('--bg-color-3'),
                        trigger: 'axis',
                        position: (point, params, dom, rect, size) => {
                            let x = point[0] - size.contentSize[0] / 2;
                            let cWidth = 375 * _this.ratio;
                            if (x < 0) {
                                x = 0;
                            } else if ((x + size.contentSize[0]) > cWidth) {
                                x = cWidth - size.contentSize[0];
                            }
                            return [x, '0%'];
                        },
                        formatter: function (params, ticket, callback) {
                            let item = params[0];
                            let value = item.data ? item.data : 0;
                            if (value == 0) {
                                return
                            }
                            let html = '';
                            html += '<div style="font-size:13px;font-family:D-D;color: ' + getSkin('--text-color-3') + '">' + item.axisValue + '</div>'
                            html += '<div style="font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + value + '%</span> </div>';
                            return html
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            fontFamily: "'D-D','SF'",
                            interval: this.activeTime === 2 ? 6 : 0,
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        max: finalMax,
                        interval: niceInterval,
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3'),
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false,
                            fontFamily: "'D-D','SF'",
                        }
                    },
                    series: [
                        {
                            name: _this.$t('activity.basalBurn'),
                            data: yData[0],
                            type: 'bar',
                            stack: 'total',
                            barWidth: barWidth,
                            label: { show: false },
                            itemStyle: {
                                color: getSkin('--chart-color-15'),
                                borderRadius: 2 * this.ratio,
                            },
                            emphasis: {
                                itemStyle: {
                                    color: getSkin('--chart-color-154'),
                                    borderRadius: 2 * this.ratio,
                                }
                            },
                        },
                        {
                            name: '',
                            type: 'bar',
                            stack: 'total',
                            barWidth: barWidth,
                            data: yData[0].map(v => v == null ? null : 2),
                            itemStyle: { color: 'rgba(0,0,0,0)' },
                            tooltip: {show: false },
                            legendHoverLink: false
                        },
                        {
                            name: _this.$t('activity.activityBurn'),
                            data: yData[1],
                            type: 'bar',
                            stack: 'total',
                            barWidth: barWidth,
                            label: {
                                show: true,
                                position: 'top',
                                color: getSkin('--text-color-1'),
                                fontSize: 11 * _this.ratio,
                                fontWeight: 'bold',
                                formatter: (params) => {
                                    if (params.data == null) return '';
                                    const deep = yData[0][params.dataIndex];
                                    const rem = yData[1][params.dataIndex];
                                    if (deep == null && rem == null) return '';
                                    const total = (deep || 0) + (rem || 0);
                                    if (total === 0) return '';
                                    if (_this.activeTime == 2) {
                                        if (total === maxVal || total === minVal) {
                                            return format(total);
                                        }
                                        return '';
                                    } else {
                                        return format(total);
                                    }
                                }
                            },
                            itemStyle: {
                                color: getSkin('--chart-color-5'),
                                borderRadius: 2 * this.ratio,
                            },
                            emphasis: {
                                itemStyle: {
                                    color: getSkin('--chart-color-54'),
                                    borderRadius: 2 * this.ratio,
                                }
                            },
                        }
                    ]
                }, true)
                // this.efficiencyChart.setOption(option);
            } else {
                this.efficiencyChart.setOption({
                    grid: {
                        top: 17 * this.ratio,
                        bottom: 47 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    title: {
                        text: this.$t('noData'),
                        x: 'center',
                        y: 70 * this.ratio,
                        textStyle: {
                            fontFamily: 'Manteka',
                            fontSize: '12',
                            fontWeight: 'normal',
                            color: getSkin('--text-color-2')
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        max: 100,
                        boundaryGap: [0, '10%'],
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false
                        }
                    },
                    series: [
                        {
                            data: [],
                            type: 'line',
                        }
                    ]
                }, true)
            }

        },
        drawStabilityChart(xData, yData) {
            let _this = this;
            let barWidth = 16 * this.ratio;
            if (this.activeTime == 1) {
                barWidth = 16 * this.ratio;
            } else {
                barWidth = 4 * this.ratio;
            }
            this.stabilityChart = this.$echarts.init(document.getElementById("stability-chart"));
            if (!this.noData) {
                const validY = yData.filter(v => v != null);
                const maxVal = validY.length > 0 ? Math.max(...validY) : 0;
                const minVal = validY.length > 0 ? Math.min(...validY) : 0;
                // 计算nice interval，确保yAxis正好显示5个刻度(含0)
                const rawInterval = (maxVal || 100) / 4;
                const magnitude = Math.pow(10, Math.floor(Math.log10(rawInterval + 0.0001)));
                const residual = rawInterval / magnitude;
                let niceInterval;
                if (residual <= 1) niceInterval = magnitude;
                else if (residual <= 2) niceInterval = 2 * magnitude;
                else if (residual <= 5) niceInterval = 5 * magnitude;
                else niceInterval = 10 * magnitude;
                const yMax = Math.ceil((maxVal || 100) / niceInterval) * niceInterval;
                const finalMax = Math.max(yMax, niceInterval * 4);
                this.stabilityChart.setOption({
                    grid: {
                        top: 17 * this.ratio,
                        bottom: 47 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    dataZoom: { // 放大和缩放
                        type: 'inside'
                    },
                    emphasis: {
                        disabled: true,
                    },
                    tooltip: {
                        borderColor: 'transparent',
                        backgroundColor: getSkin('--bg-color-3'),
                        trigger: 'axis',
                        position: (point, params, dom, rect, size) => {
                            let x = point[0] - size.contentSize[0] / 2;
                            let cWidth = 375 * _this.ratio;
                            if (x < 0) {
                                x = 0;
                            } else if ((x + size.contentSize[0]) > cWidth) {
                                x = cWidth - size.contentSize[0];
                            }
                            return [x, '0%'];
                        },
                        formatter: function (params, ticket, callback) {
                            let item = params[0];
                            let value = item.data ? item.data : 0;
                            if (value == 0) {
                                return
                            }
                            let html = '';
                            html += '<div style="font-size:13px;font-family:D-D;color: ' + getSkin('--text-color-3') + '">' + item.axisValue + '</div>'
                            html += '<div style="font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + value + '</span> </div>';
                            return html
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            fontFamily: "'D-D','SF'",
                            interval: this.activeTime === 2 ? 6 : 0,
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        max: finalMax,
                        interval: niceInterval,
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3'),
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false,
                            fontFamily: "'D-D','SF'",
                            formatter: value => value >= 1000 ? (value / 1000) + 'k' : value
                        }
                    },
                    series: [
                        {
                            data: yData,
                            type: 'bar',
                            itemStyle: {
                                color: getSkin('--chart-color-8'),
                                borderRadius: 2 * this.ratio,
                            },
                            barWidth: barWidth,
                            label: {
                                show: true,
                                position: 'top',
                                color: getSkin('--text-color-1'),
                                fontSize: 11 * this.ratio,
                                fontWeight: 'bold',
                                formatter: (params) => {
                                    if (params.data == null || params.data === 0) return '';
                                    return format(params.data);
                                },
                            },
                        }
                    ]
                }, true)
                // this.stabilityChart.setOption(option);
            } else {
                this.stabilityChart.setOption({
                    grid: {
                        top: 17 * this.ratio,
                        bottom: 47 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    title: {
                        text: this.$t('noData'),
                        x: 'center',
                        y: 70 * this.ratio,
                        textStyle: {
                            fontFamily: 'Manteka',
                            fontSize: '12',
                            fontWeight: 'normal',
                            color: getSkin('--text-color-2')
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        max: 100,
                        boundaryGap: [0, '10%'],
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false
                        }
                    },
                    series: [
                        {
                            data: [],
                            type: 'line',
                        }
                    ]
                }, true)
            }
        }
    },
    unmounted() {
        document.removeEventListener('click', this.checkClick);
    }
}
</script>

<style scoped>

.date-item img {
    margin-right: 2px;
    width: 14px;
}

.info-icon {
    width: 16px;
    margin-left: 6px;
}

.ratio-line div:first-child {
    border-radius: 5px 0px 0px 5px;
}

.ratio-line div:last-child {
    border-radius: 0px 5px 5px 0px;
}

.ratio-line div:only-child {
    border-radius: 5px 5px 5px 5px;
}

.desc-time span {
    font-size: 15px;
}

.desc-num {
    color: var(--text-color-1);
    font-size: 24px !important;
    margin: 0 3px;
}

.split {
    height: 15px;
}

.suggest-title {
    color: var(--text-color-2);
    font-size: 15px;
    margin-left: 15px;
    margin-top: 16px;
    letter-spacing: 2px;
    display: flex;
}

#range-chart {
    height: 210px;
    width: 100%;
}

.arr-opacity {
    opacity: 0.2;
}

.content-top {
    width: 100%;
    margin-top: 88px;
}

.score-chart-box {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 10px 10px 10px 10px;
    margin: 13px auto 20px;
}

.score-chart-out {
    width: 345px;
    height: 190px;
    position: relative;
}

#score-chart {
    width: 345px;
    height: 190px;
}

.avg-score-box {
    width: 200px;
    height: 200px;
    margin: 0 auto;
    position: relative;
    text-align: center;
}

.score-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 200px;
    height: 200px;
}

.avg-score-title {
    position: absolute;
    top: 60px;
    width: 200px;
    font-size: 13px;
    color: var(--text-color-3);
}

.avg-score-value {
    position: absolute;
    top: 74px;
    font-size: 44px;
    color: var(--text-color-1);
    width: 200px;
}

.compare-box {
    font-size: 13px;
    color: var(--chart-color-1);
    width: 200px;
    position: absolute;
    top: 120px;
}

.compare-text {
    font-size: 11px;
    color: var(--text-color-3);
    position: absolute;
    top: 140px;
    width: 200px;
}

.score-item {
    display: flex;
    justify-content: center;
    margin-bottom: 16px;
}

.score-img-box {
    position: relative;
    width: 140px;
}

.score-img {
    position: absolute;
    width: 140px;
    height: 14px;
}

.score-color-bar {
    width: 2px;
    height: 14px;
    border-radius: 3px;
    position: absolute;
    right: 0;
}

.score-color-1 {
    background: var(--chart-color-3);
}

.score-color-2 {
    background: var(--chart-color-5);
}

.score-color-3 {
    background: var(--chart-color-15);
}

.score-ratio {
    height: 14px;
    border-radius: 3px;
    position: absolute;
    left: 0;
}

.score-text {
    font-size: 13px;
    color: var(--text-color-1);
    margin: 0 0 0 9px;
    width: 57px;
}

.score-num-level {
    font-size: 13px;
    color: var(--text-color-3);
    width: 50px;
    float: left;
}

.score-suggest {
    font-size: 13px;
    color: var(--text-color-2);
    line-height: 18px;
    margin: 0 16px;
    padding-bottom: 16px;
}

.avg-duration-title {
    font-size: 13px;
    color: var(--text-color-1);
    padding-top: 16px;
    margin-left: 16px;
    margin-bottom: 4px;
}

.avg-efficiency-value {
    font-size: 20px;
    color: var(--text-color-1);
    margin-left: 16px;
}

.avg-efficiency-unit {
    font-size: 13px;
    color: var(--text-color-1);
    margin-left: 4px;
    margin-right: 8px;
}

.avg-efficiency-compare {
    background: var(--chart-color-1p1);
    border-radius: 3px 3px 3px 3px;
    color: var(--chart-color-1);
    font-size: 13px;
    padding: 2px 4px;
}

.avg-efficiency-line {
    display: flex;
    align-items: center;
}

.avg-efficiency-compare-value {
    margin-left: 5px;
}

#y-axis-lines {
    position: absolute;
    left: 41px;
    top: 17px;
    width: 2px;
    bottom: 47px;
}

.vs-line {
    display: flex;
    justify-content: space-between;
}

.vs-text {
    font-size: 11px;
    color: var(--text-color-3);
    margin-right: 16px;
}

#stability-chart {
    width: 345px;
    height: 190px;
}

#efficiency-chart {
    width: 345px;
    height: 210px;
}
</style>



// WEBPACK FOOTER //
// src/views/status/27activity.vue